// ViewBookingSkeleton.jsx
import React from "react";
import "./viewBookingSkeleton.css";

const ViewBookingSkeleton = () => {
	return (
		<div className="sf-skel-booking">

			{/* HEADER */}
			<div className="sf-skel-row gap">
				<div className="sf-skel-circle shimmer"></div>
				<div className="sf-skel-line w-55 shimmer"></div>
			</div>

			{/* STATUS BADGE */}
			<div className="sf-skel-badge shimmer"></div>

			{/* MAP BLOCK */}
			<div className="sf-skel-map shimmer"></div>

			{/* SHOP NAME */}
			<div className="sf-skel-center">
				<div className="sf-skel-line w-40 shimmer"></div>
			</div>

			{/* DETAILS CARD */}
			<div className="sf-skel-details">
				{Array.from({ length: 3 }).map((_, i) => (
					<div className="sf-skel-detail-row" key={i}>
						<div className="sf-skel-line w-30 shimmer"></div>
						<div className="sf-skel-line w-50 shimmer"></div>
					</div>
				))}
			</div>

			{/* ACTION BUTTONS */}
			<div className="sf-skel-actions">
				<div className="sf-skel-btn shimmer"></div>
				<div className="sf-skel-btn shimmer"></div>
			</div>

			{/* REVIEW BOX (still loading) */}
			<div className="sf-skel-review-box">
				<div className="sf-skel-line w-50 shimmer"></div>
				<div className="sf-skel-line w-80 shimmer"></div>
				<div className="sf-skel-btn-wide shimmer"></div>
			</div>
		</div>
	);
};

export default ViewBookingSkeleton;
